import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/agendamento`

    return {
        autocomplete: (queryParms = {}) => {
            return repository.get(`${baseUrl}/autocomplete?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        getJornadas(queryParms) {

            return repository.get(`${baseUrl}/getJornadas?${urlUtil.serialize(queryParms)}`)
        },
        getSupervisores(queryParms) {

            return repository.get(`${baseUrl}/getSupervisores?${urlUtil.serialize(queryParms)}`)
        },
        getGrupo(queryParms) {

            return repository.get(`${baseUrl}/grupo?${urlUtil.serialize(queryParms)}`)
        },
        getProfissional(queryParms) {

            return repository.get(`${baseUrl}/profissional?${urlUtil.serialize(queryParms)}`)
        },
        getValorUtilizadoPeriodo(queryParms) {

            return repository.get(`${baseUrl}/getValorUtilizadoPeriodo?${urlUtil.serialize(queryParms)}`)
        },
        cancel(id, params) {
            return repository.put(`${baseUrl}/${id}/cancel`, params)
        },
        getExameAmbulatorioAtendimento(queryParms) {
            return repository.get(`${baseUrl}/exame-ambulatorio-atendimento?${urlUtil.serialize(queryParms)}`)
        },
        descartarExameAmbulatorioAtendimento(params) {
            return repository.post(`${baseUrl}/descartar-exame-ambulatorio-atendimento`, params)
        },
        hasSolicitacaoRegulacao(queryParms) {
            return repository.get(`${baseUrl}/has-solicitacao-regulacao?${urlUtil.serialize(queryParms)}`)
        },
    }
}